// Builds a table of contents from the h2/h3 headings inside a post's content.
// The TOC container (`[data-toc]`) ships hidden and is only revealed when the
// post actually has two or more headings to link to.
(function () {
    var toc = document.querySelector('[data-toc]');
    if (!toc) return;
    var content = document.querySelector('.gh-content');
    if (!content) return;

    var headings = content.querySelectorAll('h2, h3');
    if (headings.length < 2) return;

    var list = toc.querySelector('.gh-toc-list');
    if (!list) return;

    var used = {};
    function slugify(text) {
        var slug = text.toLowerCase().trim()
            .replace(/[^\w\s-]/g, '')
            .replace(/\s+/g, '-')
            .replace(/-+/g, '-');
        return slug || 'section';
    }

    var ul = document.createElement('ul');
    Array.prototype.forEach.call(headings, function (h) {
        if (!h.id) {
            var base = slugify(h.textContent);
            var id = base;
            var n = 2;
            while (used[id] || document.getElementById(id)) {
                id = base + '-' + n++;
            }
            h.id = id;
        }
        used[h.id] = true;

        var li = document.createElement('li');
        li.className = 'gh-toc-item gh-toc-' + h.tagName.toLowerCase();
        var a = document.createElement('a');
        a.href = '#' + h.id;
        a.textContent = h.textContent;
        li.appendChild(a);
        ul.appendChild(li);
    });
    list.appendChild(ul);

    toc.removeAttribute('hidden');
    document.body.classList.add('has-toc');

    var btn = toc.querySelector('.gh-toc-toggle');
    if (btn) {
        btn.addEventListener('click', function () {
            var collapsed = toc.classList.toggle('is-collapsed');
            btn.setAttribute('aria-expanded', String(!collapsed));
        });
    }

    // Highlight the section currently in view.
    if ('IntersectionObserver' in window) {
        var links = {};
        Array.prototype.forEach.call(list.querySelectorAll('a'), function (a) {
            links[a.getAttribute('href').slice(1)] = a;
        });
        var observer = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
                var a = links[entry.target.id];
                if (!a || !entry.isIntersecting) return;
                Object.keys(links).forEach(function (k) {
                    links[k].classList.remove('is-active');
                });
                a.classList.add('is-active');
            });
        }, { rootMargin: '0px 0px -75% 0px' });
        Array.prototype.forEach.call(headings, function (h) {
            observer.observe(h);
        });
    }
})();
